export default __webpack_public_path__ + "static/5-unique-ways-to-experience-french-delicacies-bread-v2-e83aaba364f3abfae1897fcaeb857f1d.jpg";